import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/shared";

export default function WorkerSettings() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div data-testid="worker-settings">
      <PageHeader title={t("wNav.settings")} />
      <div className="card-soft p-6">
        <div className="space-y-2 text-sm">
          <div className="flex justify-between border-b border-slate-50 py-2"><span className="text-slate-400">{t("worker.name")}</span><span className="font-medium text-navy">{user?.first_name} {user?.last_name}</span></div>
          <div className="flex justify-between py-2"><span className="text-slate-400">{t("login.email")}</span><span className="font-medium text-navy">{user?.email}</span></div>
        </div>
        <Button variant="outline" className="mt-6 rounded-full text-red-600" onClick={async () => { await logout(); nav("/login"); }} data-testid="worker-settings-logout"><LogOut className="mr-2 h-4 w-4" /> {t("wNav.logout")}</Button>
      </div>
    </div>
  );
}
